import React from 'react';
import { RadioGroup, Radio } from 'react-radio-group';
import ReactHtmlParser from 'html-react-parser';
import { generateUUID } from '../../../../utils';
import Element from '../../../../components/element';
import { Checkbox, CheckboxGroup } from 'react-checkbox-group';
import { isObject, map, values } from 'lodash';

class RadioSurvey extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: null,
      hideOther: true,
      other: '',
      displayText: false,
      checkboxSelected: []
    };
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { rawAnswers, index, storeAnswer, checkSurveyState } = this.props;
    if (rawAnswers) {
      this.setState(rawAnswers, () => {
        checkSurveyState(this);
      });
    } else {
      // storeAnswer(index, this.state);
    }
  }

  handleRadioChange(selected) {
    const {
      storeAnswer,
      index,
      checkSurveyState,
      checkRouteMap,
      otherOption,
      questionId,
      routeMap
    } = this.props;
    let isQuestionAnsweredLocal = false;
    this.setState({ ...this.state, others: '' });

    if (
      selected === 'Other' &&
      window.location.pathname?.includes('nutrition')
    ) {
      this.setState({ hideOther: false });
      this.setState({ displayText: true });
    } else {
      this.setState({ displayText: false });
    }

    if (selected.toLowerCase() === 'other' && otherOption) {
      this.setState({ hideOther: false });
    } else {
      this.setState({ hideOther: true });
    }
    if (
      !(
        selected ===
        'I am having some health or lifestyle issues which I would like to address.'
      )
    ) {
      this.setState({
        checkboxSelected: []
      });
      if (selected === 'Other' && this.state.other === '') {
        isQuestionAnsweredLocal = false;
      } else {
        isQuestionAnsweredLocal = true;
      }
    } else {
      isQuestionAnsweredLocal = this.state.checkboxSelected.length > 0;
    }
    this.setState({ selected }, () => {
      storeAnswer(
        questionId,
        this.state,
        isQuestionAnsweredLocal,
        routeMap,
        'selected'
      );
    });
  }
  handleCheckboxChange(checkboxSelected) {
    const { storeAnswer, questionId, routeMap } = this.props;
    let isQuestionAnsweredLocal = false;
    if (checkboxSelected.length > 0) {
      this.setState({
        selected:
          'I am having some health or lifestyle issues which I would like to address.'
      });
      // isQuestionAnsweredLocal = true;
      isQuestionAnsweredLocal = this.isQuestionAnswered();
    } else {
      if (
        this.state.selected ===
        'I am having some health or lifestyle issues which I would like to address.'
      ) {
        isQuestionAnsweredLocal = false;
      }
    }

    this.setState({ checkboxSelected }, () => {
      storeAnswer(
        questionId,
        this.state,
        isQuestionAnsweredLocal,
        routeMap,
        'selected'
      );
    });
  }

  handleChange = e => {
    const { storeAnswer, questionId, routeMap } = this.props;
    const value = e.target.value;
    const newState = { ...this.state, others: value };
    this.setState(newState, () => {
      storeAnswer(
        questionId,
        newState,
        this.isQuestionAnswered(newState),
        routeMap,
        'selected'
      );
    });
  };

  handleTextChange(e) {
    const { storeAnswer, questionId, routeMap } = this.props;
    let isQuestionAnsweredLocal = false;
    if (this.state.selected === 'Other' && e.target.value === '') {
      isQuestionAnsweredLocal = false;
    } else {
      isQuestionAnsweredLocal = this.isQuestionAnswered();
    }
    this.setState({ other: e.target.value }, () => {
      storeAnswer(
        questionId,
        this.state,
        isQuestionAnsweredLocal,
        routeMap,
        'selected'
      );
      // checkSurveyState(this);
    });
  }

  isQuestionAnswered = () => {
    return !!this.state.selected;
  };

  render() {
    const {
      options,
      question,
      fullWidth,
      otherOption,
      className,
      notRequired,
      horizontal
    } = this.props;
    let newOptions;
    let oldOptions = [];
    if (isObject(options)) {
      oldOptions = values(options);
    }
    if (otherOption) {
      newOptions = [...oldOptions, 'Other'];
    } else {
      newOptions = oldOptions;
    }

    return (
      <div className={`${className}`}>
        <Element type="p" fontFamily="GTAM" fontSize="14px">
          {ReactHtmlParser(question)}
        </Element>
        <Element
          type={RadioGroup}
          attrs={{
            selectedValue: this.state.selected,
            onChange: this.handleRadioChange,
            name: `radio-${this.props.index}`
          }}
          {...(horizontal && { display: 'flex' })}
        >
          {newOptions.map((input, index) => {
            const UUID = generateUUID();
            const required = index === 0 && !notRequired;

            return (
              <div>
                <div
                  className={
                    fullWidth
                      ? 'survey-radio-full'
                      : this.props.checkbox
                        ? 'survey-checkbox-radio'
                        : 'survey-radio'
                  }
                  key={index}
                >
                  <Radio
                    id={UUID}
                    className={this.props.isOldVisit ? 'survey-disabled' : ''}
                    required={required}
                    disabled={this.props.isOldVisit}
                    value={input}
                  />
                  <label
                    className={this.props.isOldVisit ? 'survey-disabled' : ''}
                    htmlFor={UUID}
                    style={{ fontFamily: 'GTAR' }}
                  >
                    {input}
                  </label>
                </div>
                {this.props.checkbox &&
                  this.props.checkbox.radioOption === input && (
                    <Element
                      type={CheckboxGroup}
                      attrs={{
                        value: this.state.checkboxSelected,
                        onChange: this.handleCheckboxChange,
                        name: `radio-${this.props.index}`
                      }}
                      marginLeft="30px"
                    >
                      {map(this.props.checkbox.options, option => {
                        const keyOrId = `${this.props.questionId}_${option}`;
                        return (
                          <Element
                            display="flex"
                            alignItems="center"
                            marginBottom="12px"
                          >
                            <Checkbox
                              key={keyOrId}
                              id={keyOrId}
                              value={option}
                            />
                            <Element
                              type="label"
                              attrs={{ htmlFor: keyOrId }}
                              marginBottom={0}
                              marginLeft="8px"
                              fontFamily="GTAR"
                              fontSize="12px"
                              color="#222222"
                            >
                              {option}
                            </Element>
                          </Element>
                        );
                      })}
                    </Element>
                  )}
              </div>
            );
          })}
          {this.state.displayText && (
            <Element
              type="input"
              attrs={{
                type: 'text',
                value: this.state.others,
                onChange: this.handleChange
              }}
              className={`survey-text survey-item-${this.state.className}`}
            />
          )}
        </Element>
        {/* <RadioGroup
          selectedValue={this.state.selected}
          onChange={this.handleRadioChange}
          name={`radio-${this.props.index}`}
        >
          {newOptions.map((input, index) => {
            const UUID = generateUUID();
            const required = index === 0 && !notRequired;

            return (
              <div
                className={fullWidth ? 'survey-radio-full' : 'survey-radio'}
                key={index}
              >
                <Radio
                  id={UUID}
                  className={this.props.isOldVisit ? 'survey-disabled' : ''}
                  required={required}
                  disabled={this.props.isOldVisit}
                  value={input}
                />
                <label
                  className={this.props.isOldVisit ? 'survey-disabled' : ''}
                  htmlFor={UUID}
                >
                  {input}
                </label>
              </div>
            );
          })}
        </RadioGroup> */}
        {!this.state.hideOther && (
          <div>
            <div style={{ width: '350px' }}>
              <input
                type="text"
                onChange={e => this.handleTextChange(e)}
                className={`survey-text`}
                value={this.state.other}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default RadioSurvey;
